<div id="getting-started"></div>
<app-publicnavbar></app-publicnavbar>


<main>
    <div class="container py-4">
<!--
      <div class="row align-items-md-stretch">
        <div class="col-md-6"> 
          <div class="h-100 p-5 text-white rounded-3" style="background-color: #7d3f98">
            <h4>Patient Access and Payer to Payer API</h4>
            <p>The Patient Access API allows Aetna members to access their claims and encounter information using third-party developers' and payers' applications.</p>
            <button class="btn btn-outline-light" type="button" (click)="PublicPatientAccess()">View
              
            </button> 
 
          </div>
        </div>

        
            <div class="col-md-6"> 
            <div class="h-100 p-5  text-white rounded-3" style="background-color: #7d3f98">
                <h4>Provider Directory API</h4>
                <p>The Provider Directory API allows third-party developers and payers to access information about the Provider Directory.</p>
               <button class="btn btn-outline-light"  type="button" (click)="PublicProviderDirectoryApi()">View
                  
                </button> 
                
                
            </div>
            </div>

            <div class="col-md-6"> 
              <br>
              <div class="h-100 p-5 text-white rounded-3" style="background-color: #7d3f98">
                <h4>Provider Access API</h4>
                <p>The Provider Access API allows Providers/EMR systems to view all the members that are attributed to their group.</p>
                <button class="btn btn-outline-light" type="button" (click)="ProviderAccessApi()">View
                  
                </button> 
     
              </div>
            </div>
       
      </div>
    -->
    <div>
      <B style="color: #7d3f98;font-size: 20px;">Aetna’s Interoperability Products</B>
      <p>To see the FHIR resources, supported versions, and profile for each product, click “View".</p>
    </div>
    <div class="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm" style="background-color: #7d3f98;width: 60%;">
      <div class="lh-1">
        <h1 class="h6 mb-0 text-white lh-1">Patient Access API</h1>
      </div>
     
      <button class="btn btn-outline-light" type="button" (click)="PublicPatientAccess()" style="margin-left: auto; width: 16%;">
        View 
      </button> 
   
     
    </div>
     
      <div class="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm" style="background-color: #7d3f98;width: 60%;">
       
      
        <div class="lh-1">
          <h1 class="h6 mb-0 text-white lh-1">Payer-to-Payer API</h1>
        </div>

        <button style="margin-left: auto; width: 16%;" class="btn btn-outline-light" type="button" (click)="PublicPatientAccess()">
          View
        </button> 
      </div>
    
      <div class="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm" style="background-color: #7d3f98;width: 60%;">
       
        <div class="lh-1">
          <h1 class="h6 mb-0 text-white lh-1">Provider Directory API</h1>
        </div>
        <button style="margin-left: auto; width: 16%;" class="btn btn-outline-light" type="button" (click)="PublicProviderDirectoryApi()">
          View
        </button> 
      </div>

      <div class="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm" style="background-color: #7d3f98;width: 60%;">
       
      
        <div class="lh-1">
          <h1 class="h6 mb-0 text-white lh-1">Prior Authorization API</h1>
        </div>

        <button style="margin-left: auto; width: 16%;" class="btn btn-outline-light" type="button" (click)="ProviderAccessApi()">
          View
        </button> 
      </div>

      <div class="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm" style="background-color: #7d3f98;width: 60%;">
       
       
        <div class="lh-1">
          <h1 class="h6 mb-0 text-white lh-1">Provider Access API</h1>
        </div>

        <button style="margin-left: auto; width: 16%;" class="btn btn-outline-light" type="button" (click)="ProviderAccessApi()">
          View
        </button> 
      </div>
     
    </div>

   
   
  </main>

 
  


